import {makeAutoObservable} from "mobx";
import * as Api from 'api/api'
import FetchDataStatus from "../../../enum/FetchDataStatus";

class HomeLookAroundStore {
    loading = true
    list = []

    fetchCount = 0;

    async fetchData() {
        this.loading = true
        const list = await Api.fetchLookAround();
        this.list = [
            ...this.list,
            ...list
        ]
        this.loading = false
        this.fetchCount = this.fetchCount + 1
    }

    get canLoadMoreData() {
        return (this.fetchCount <= 3 && !this.loading);
    }

    get notFetch() {
        return this.fetchCount === 0
    }

    constructor() {
        makeAutoObservable(this)
    }
}

export default HomeLookAroundStore